module.exports = __webpack_public_path__ + "static/img/item7.6cef42b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/teacher/item7.png
// module id = uhmn
// module chunks = 63